/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: dibWfFuvP_0V
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  set as $stateSet,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: Utk5Dv_x15H2/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicOp1WebForumPostPreview.module.css"; // plasmic-import: dibWfFuvP_0V/css

createPlasmicElementProxy;

export const PlasmicOp1WebForumPostPreview__VariantProps = new Array(
  "isHovered"
);

export const PlasmicOp1WebForumPostPreview__ArgProps = new Array("showTitle");

const $$ = {};

function PlasmicOp1WebForumPostPreview__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          showTitle: true
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "isHovered",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isHovered
      }
    ],

    [$props, $ctx, $refs]
  );
  const currentUser = useCurrentUser?.() || {};
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"formPreviewPost4"}
      data-plasmic-override={overrides.formPreviewPost4}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_nJ1Nn58LcfAm7wemZm71QH",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.formPreviewPost4,
        {
          [sty.formPreviewPost4isHovered]: hasVariant(
            $state,
            "isHovered",
            "isHovered"
          )
        }
      )}
      onClick={async event => {
        const $steps = {};
        $steps["goToOp1WebArticleX"] = true
          ? (() => {
              const actionArgs = { destination: `/community/forum/article-x` };
              return (({ destination }) => {
                if (
                  typeof destination === "string" &&
                  destination.startsWith("#")
                ) {
                  document
                    .getElementById(destination.substr(1))
                    .scrollIntoView({ behavior: "smooth" });
                } else {
                  location.assign(destination);
                }
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["goToOp1WebArticleX"] != null &&
          typeof $steps["goToOp1WebArticleX"] === "object" &&
          typeof $steps["goToOp1WebArticleX"].then === "function"
        ) {
          $steps["goToOp1WebArticleX"] = await $steps["goToOp1WebArticleX"];
        }
      }}
      onMouseEnter={async event => {
        const $steps = {};
        $steps["updateIsHovered"] = true
          ? (() => {
              const actionArgs = {
                vgroup: "isHovered",
                operation: 4,
                value: "isHovered"
              };
              return (({ vgroup, value }) => {
                if (typeof value === "string") {
                  value = [value];
                }
                $stateSet($state, vgroup, true);
                return true;
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["updateIsHovered"] != null &&
          typeof $steps["updateIsHovered"] === "object" &&
          typeof $steps["updateIsHovered"].then === "function"
        ) {
          $steps["updateIsHovered"] = await $steps["updateIsHovered"];
        }
      }}
      onMouseLeave={async event => {
        const $steps = {};
        $steps["updateIsHovered"] = true
          ? (() => {
              const actionArgs = {
                vgroup: "isHovered",
                operation: 6,
                value: "isHovered"
              };
              return (({ vgroup, value }) => {
                if (typeof value === "string") {
                  value = [value];
                }
                $stateSet($state, vgroup, false);
                return false;
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["updateIsHovered"] != null &&
          typeof $steps["updateIsHovered"] === "object" &&
          typeof $steps["updateIsHovered"].then === "function"
        ) {
          $steps["updateIsHovered"] = await $steps["updateIsHovered"];
        }
      }}
    >
      <div
        data-plasmic-name={"frame454"}
        data-plasmic-override={overrides.frame454}
        className={classNames("all", sty.frame454, {
          [sty.frame454isHovered]: hasVariant($state, "isHovered", "isHovered")
        })}
      >
        <div
          data-plasmic-name={"header"}
          data-plasmic-override={overrides.header}
          className={classNames("all", sty.header)}
        >
          <div
            data-plasmic-name={"avatar"}
            data-plasmic-override={overrides.avatar}
            className={classNames("all", sty.avatar)}
          />

          <div
            data-plasmic-name={"info"}
            data-plasmic-override={overrides.info}
            className={classNames("all", sty.info)}
          >
            <div
              data-plasmic-name={"frame389"}
              data-plasmic-override={overrides.frame389}
              className={classNames("all", sty.frame389)}
            >
              <div className={classNames("all", "__wab_text", sty.text___4Pgh)}>
                {"JOHN1"}
              </div>
            </div>
            <div
              data-plasmic-name={"frame423"}
              data-plasmic-override={overrides.frame423}
              className={classNames("all", sty.frame423, {
                [sty.frame423isHovered]: hasVariant(
                  $state,
                  "isHovered",
                  "isHovered"
                )
              })}
            >
              <div className={classNames("all", "__wab_text", sty.text__zAbgr)}>
                {"[ @dr.john1000 ]"}
              </div>
              <div className={classNames("all", "__wab_text", sty.text__adPqi)}>
                {"\u2022"}
              </div>
              <div className={classNames("all", "__wab_text", sty.text__xyQa4)}>
                {"18h"}
              </div>
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"frame25"}
          data-plasmic-override={overrides.frame25}
          className={classNames("all", sty.frame25)}
        >
          {(() => {
            try {
              return $props.showTitle;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return true;
              }
              throw e;
            }
          })() ? (
            <div
              data-plasmic-name={"postTitle3"}
              data-plasmic-override={overrides.postTitle3}
              className={classNames("all", "__wab_text", sty.postTitle3)}
            >
              {"Cross-platform holistic encryption."}
            </div>
          ) : null}
          <div
            data-plasmic-name={
              "loremIpsumDolorSitAmetConsecteturQuisDictumAcRisusSitNuncSagittisEuFacilisiSemperAtViverraProinRisusSedNecJustoNibh2"
            }
            data-plasmic-override={
              overrides.loremIpsumDolorSitAmetConsecteturQuisDictumAcRisusSitNuncSagittisEuFacilisiSemperAtViverraProinRisusSedNecJustoNibh2
            }
            className={classNames(
              "all",
              "__wab_text",
              sty.loremIpsumDolorSitAmetConsecteturQuisDictumAcRisusSitNuncSagittisEuFacilisiSemperAtViverraProinRisusSedNecJustoNibh2,
              {
                [sty.loremIpsumDolorSitAmetConsecteturQuisDictumAcRisusSitNuncSagittisEuFacilisiSemperAtViverraProinRisusSedNecJustoNibh2isHovered]:
                  hasVariant($state, "isHovered", "isHovered")
              }
            )}
          >
            {
              "Lorem ipsum dolor sit amet consectetur. Mauris dolor quam molestie a netus et. Egestas nisl tincidunt arcu vel diam lectus. At ullamcorper tempor eget enim eleifend. At leo in in eget natoque. Et iaculis nibh mauris condimentum et. Sagittis rhoncus aliquet fusce neque aliquet enim commodo. Tellus non sit egestas eget amet quam laoreet sodales. In etiam fermentum nibh nunc habitant sed id dapibus odio."
            }
          </div>
        </div>
        <div
          data-plasmic-name={"actionsWrapper3"}
          data-plasmic-override={overrides.actionsWrapper3}
          className={classNames("all", sty.actionsWrapper3, {
            [sty.actionsWrapper3isHovered]: hasVariant(
              $state,
              "isHovered",
              "isHovered"
            )
          })}
        >
          <div
            data-plasmic-name={"frame424"}
            data-plasmic-override={overrides.frame424}
            className={classNames("all", sty.frame424, {
              [sty.frame424isHovered]: hasVariant(
                $state,
                "isHovered",
                "isHovered"
              )
            })}
          >
            <ButtonPrimary
              className={classNames(
                "__wab_instance",
                sty.buttonPrimary__vDSao,
                {
                  [sty.buttonPrimaryisHovered__vDSaoEyEht]: hasVariant(
                    $state,
                    "isHovered",
                    "isHovered"
                  )
                }
              )}
              color={"supaLight"}
              content={"view more"}
              onClick={async () => {
                const $steps = {};
                $steps["goToOp1WebArticleX"] = true
                  ? (() => {
                      const actionArgs = {
                        destination: `/community/forum/article-x`
                      };
                      return (({ destination }) => {
                        if (
                          typeof destination === "string" &&
                          destination.startsWith("#")
                        ) {
                          document
                            .getElementById(destination.substr(1))
                            .scrollIntoView({ behavior: "smooth" });
                        } else {
                          location.assign(destination);
                        }
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["goToOp1WebArticleX"] != null &&
                  typeof $steps["goToOp1WebArticleX"] === "object" &&
                  typeof $steps["goToOp1WebArticleX"].then === "function"
                ) {
                  $steps["goToOp1WebArticleX"] =
                    await $steps["goToOp1WebArticleX"];
                }
              }}
              size={"small"}
              ststus={"normal"}
            />

            <ButtonPrimary
              className={classNames(
                "__wab_instance",
                sty.buttonPrimary___0SNGq,
                {
                  [sty.buttonPrimaryisHovered___0SNGqEyEht]: hasVariant(
                    $state,
                    "isHovered",
                    "isHovered"
                  )
                }
              )}
              color={"supaLight"}
              content={"add a comment"}
              size={"small"}
              ststus={"normal"}
            />
          </div>
          <div
            data-plasmic-name={"_72Replies3"}
            data-plasmic-override={overrides._72Replies3}
            className={classNames("all", sty._72Replies3)}
          >
            <div className={classNames("all", "__wab_text", sty.text__aNSg1)}>
              {"72 replies."}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  formPreviewPost4: [
    "formPreviewPost4",
    "frame454",
    "header",
    "avatar",
    "info",
    "frame389",
    "frame423",
    "frame25",
    "postTitle3",
    "loremIpsumDolorSitAmetConsecteturQuisDictumAcRisusSitNuncSagittisEuFacilisiSemperAtViverraProinRisusSedNecJustoNibh2",
    "actionsWrapper3",
    "frame424",
    "_72Replies3"
  ],

  frame454: [
    "frame454",
    "header",
    "avatar",
    "info",
    "frame389",
    "frame423",
    "frame25",
    "postTitle3",
    "loremIpsumDolorSitAmetConsecteturQuisDictumAcRisusSitNuncSagittisEuFacilisiSemperAtViverraProinRisusSedNecJustoNibh2",
    "actionsWrapper3",
    "frame424",
    "_72Replies3"
  ],

  header: ["header", "avatar", "info", "frame389", "frame423"],
  avatar: ["avatar"],
  info: ["info", "frame389", "frame423"],
  frame389: ["frame389"],
  frame423: ["frame423"],
  frame25: [
    "frame25",
    "postTitle3",
    "loremIpsumDolorSitAmetConsecteturQuisDictumAcRisusSitNuncSagittisEuFacilisiSemperAtViverraProinRisusSedNecJustoNibh2"
  ],

  postTitle3: ["postTitle3"],
  loremIpsumDolorSitAmetConsecteturQuisDictumAcRisusSitNuncSagittisEuFacilisiSemperAtViverraProinRisusSedNecJustoNibh2:
    [
      "loremIpsumDolorSitAmetConsecteturQuisDictumAcRisusSitNuncSagittisEuFacilisiSemperAtViverraProinRisusSedNecJustoNibh2"
    ],

  actionsWrapper3: ["actionsWrapper3", "frame424", "_72Replies3"],
  frame424: ["frame424"],
  _72Replies3: ["_72Replies3"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOp1WebForumPostPreview__ArgProps,
          internalVariantPropNames: PlasmicOp1WebForumPostPreview__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOp1WebForumPostPreview__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "formPreviewPost4") {
    func.displayName = "PlasmicOp1WebForumPostPreview";
  } else {
    func.displayName = `PlasmicOp1WebForumPostPreview.${nodeName}`;
  }
  return func;
}

export const PlasmicOp1WebForumPostPreview = Object.assign(
  // Top-level PlasmicOp1WebForumPostPreview renders the root element
  makeNodeComponent("formPreviewPost4"),
  {
    // Helper components rendering sub-elements
    frame454: makeNodeComponent("frame454"),
    header: makeNodeComponent("header"),
    avatar: makeNodeComponent("avatar"),
    info: makeNodeComponent("info"),
    frame389: makeNodeComponent("frame389"),
    frame423: makeNodeComponent("frame423"),
    frame25: makeNodeComponent("frame25"),
    postTitle3: makeNodeComponent("postTitle3"),
    loremIpsumDolorSitAmetConsecteturQuisDictumAcRisusSitNuncSagittisEuFacilisiSemperAtViverraProinRisusSedNecJustoNibh2:
      makeNodeComponent(
        "loremIpsumDolorSitAmetConsecteturQuisDictumAcRisusSitNuncSagittisEuFacilisiSemperAtViverraProinRisusSedNecJustoNibh2"
      ),
    actionsWrapper3: makeNodeComponent("actionsWrapper3"),
    frame424: makeNodeComponent("frame424"),
    _72Replies3: makeNodeComponent("_72Replies3"),
    // Metadata about props expected for PlasmicOp1WebForumPostPreview
    internalVariantProps: PlasmicOp1WebForumPostPreview__VariantProps,
    internalArgProps: PlasmicOp1WebForumPostPreview__ArgProps
  }
);

export default PlasmicOp1WebForumPostPreview;
/* prettier-ignore-end */
